import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from "firebase/app-check";

let activeApp;
let instance;

export function configureAppCheck(app, { emulator = false, siteKey, provider = "enterprise" } = {}) {
  if (emulator) return null;
  if (!siteKey) return null;
  if (activeApp === app && instance) return instance;
  if (!["enterprise", "v3"].includes(provider)) throw new Error("Unsupported App Check provider.");
  instance = initializeAppCheck(app, {
    provider: provider === "enterprise" ? new ReCaptchaEnterpriseProvider(siteKey) : new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
  activeApp = app;
  return instance;
}
